import * as Html from "../../util/Html.ts";
import { checkInput, isDomEmpty, type ValidationFunction } from "../../util/forms.ts";
import * as i18n from "../../i18n.ts";

export {initDom}
Html.registerWidget('widget/form/required',{initDom})


const validate: ValidationFunction = (inputDom: HTMLElement) => {
  const input = inputDom as HTMLInputElement;
  if(!input.disabled){
    const isEmptyInputName = input.getAttribute("required-if-empty");
    const isEmptyInput = input.form?.[isEmptyInputName] as HTMLInputElement;
    if(isEmptyInput && !isDomEmpty(isEmptyInput)){
      return true;
    }
    if(input.checked){
      return true;
    }
    if(isDomEmpty(input)){
      const key = input.getAttribute("data-fw-form-required-error")||"fw2.fields.requiredError";
      throw new Error(i18n.get(key, input.getAttribute("placeholder")));
    }
  }
  return true;
}

function initDom(input: HTMLElement){
  checkInput(input as HTMLInputElement, validate, "");
}